import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { fetchEquipo } from '../lib/equipoApi';

/**
 * Pantalla que ve un MIEMBRO cuando llega a cambiar el plan (spec 2026-09-11-invitaciones-equipo §4.3).
 * Un guard en las dos pantallas de plan (Checkout y Paywall) cubre todos los CTAs de
 * "mejorar plan" de la app sin tocar cada uno.
 */
export const SoloElDueno = () => {
  const navigate = useNavigate();
  const [dueno, setDueno] = useState<string | null>(null);
  useEffect(() => {
    fetchEquipo()
      .then((e) => setDueno(e.miembros.find((m) => m.esDueno)?.nombre ?? null))
      .catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-[#EFF0F5] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-black/[0.06] p-8 text-center">
        <Lock className="w-10 h-10 text-brand-primary mx-auto mb-4" />
        <h1 className="text-[20px] font-semibold text-brand-black">
          Solo el dueño de la cuenta{dueno ? ` (${dueno})` : ''} puede cambiar el plan
        </h1>
        <p className="text-[15px] text-neutral-500 mt-2">Pedile que lo haga desde su cuenta de Atlas.</p>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mt-6 w-full py-2.5 px-5 rounded-lg bg-brand-primary text-white text-[15px] font-medium"
        >
          Volver
        </button>
      </div>
    </div>
  );
};

export default SoloElDueno;
